import Dimmer from 'semantic-ui-react/dist/commonjs/modules/Dimmer';

export default Dimmer;
